<template>
  <el-tooltip
    class="item"
    effect="dark"
    placement="top-end"
    :open-delay="openDelay"
    :content="tipContent"
  >
    <el-button
      :type="btnType"
      :icon="btnIcon"
      :size="btnSize"
      :class="btnClass"
      @click="click"
      :loading="isLoading"
      :disabled="isDisabled"
      >
      <slot></slot>
    </el-button>
  </el-tooltip>
</template>

<script>

import { defCreate } from '@/api/default'

export default {
  name: 'confirm-btn',
  props: {
    msgBase: {
      type: String,
      required: true
    },
    msgData: {
      type: Object,
      default: () => {
        return null
      }
    },
    reqPath: {
      type: String,
      required: true
    },
    reqData: {
      type: Object,
      default: () => {
        return null
      }
    },
    after: {
      type: Function,
      default: () => {}
    },
    actFn: {
      type: Function,
      default: defCreate
    },
    resFn: {
      type: Function
    },
    tip: {
      type: String
    },
    btnType: {
      type: String,
      default: 'info'
    },
    btnClass: {
      type: String,
      default: 'item orange'
    },
    btnSize: {
      type: String,
      default: 'small'
    },
    btnIcon: {
      type: String,
      default: 'el-icon-refresh'
    },
    infoText: {
      type: String,
      default: ''
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    openDelay: {
      type: Number,
      default: 500
    }
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    tipContent () {
      return this.tip || this.$t(this.msgBase + 'btnTip')
    }
  },
  methods: {
    click () {
      this.$confirm(
        this.infoText + this.$t(this.msgBase + 'confirmMsg', this.msgData),
        this.$t(this.msgBase + 'confirmTitle'),
        {
          confirmButtonLoading: false,
          confirmButtonText: this.$t('api.confirmBtn'),
          cancelButtonText: this.$t('api.cancelBtn'),
          confirmButtonClass: 'el-button--danger',
          type: 'warning',
          dangerouslyUseHTMLString: true
        }
      ).then(() => {
        this.isLoading = true
        this.actFn(this.reqPath, this.reqData).then(res => {
          if (this.resFn) {
            if (this.resFn(res)) {
              return
            }
          }
          this.$message({
            message: this.$t(this.msgBase + 'successMsg'),
            type: 'success',
            duration: 2000
          })
        }).catch(err => {
          console.log(err)
        }).then(() => {
          this.isLoading = false
          this.after()
        })
      })
    }
  }
}
</script>
